export const BOTTOM_BORDER_Z_INDEX = 7;
